import { Component, Input, OnInit } from '@angular/core';
import { Ticket, TicketLog } from 'src/app/models';
import { utils } from 'src/app/shared';
import { TcDataService } from 'src/app/shared/services';

@Component({
  selector: 'ts-body-header',
  templateUrl: './ts-body-header.component.html',
  standalone: false,
})
export class TsBodyHeaderComponent implements OnInit {
  @Input() unconfirmedTicket?: Ticket;
  @Input() openedLogs?: TicketLog[];
  @Input() loadingLogs?: boolean;
  constructor(public dataService: TcDataService) {}

  ngOnInit(): void {}

  isSprintCanWrite() {
    return utils.checkAccess(['Sprint'], true, true).result;
  }
}
